// extracted by mini-css-extract-plugin
export default {"a0":"ToolsMenu-cls1_DMS","a1":"ToolsMenu-cls1_DMS","cls1":"ToolsMenu-cls1_va_","cls2":"ToolsMenu-cls2_OQW ToolsMenu-cls1_va_"};